export const STAFF_ROLES = [
    'admin',
    'manager',
    'adler_iw',
    'idler_iw',
    'stler',
    'chef',
    'gast',
    'idler_tw',
    'adler_tw',
];

export const CLIENT_ROLES = [
    'client',
    'client_manager',
    'client_worker',
    'client_unpaid'
];